module.exports = __webpack_public_path__ + "img/macOS.f276d3f.svg";